import { render, staticRenderFns } from "./hot-deals.vue?vue&type=template&id=a3f0e458&"
import script from "./hot-deals.vue?vue&type=script&lang=js&"
export * from "./hot-deals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports